/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewVirustotalDataEmpty
 */
export interface CRSFSecReviewVirustotalDataEmpty {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewVirustotalDataEmpty
     */
    asset: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof CRSFSecReviewVirustotalDataEmpty
     */
    detected_urls?: Array<any>;
}

/**
 * Check if a given object implements the CRSFSecReviewVirustotalDataEmpty interface.
 */
export function instanceOfCRSFSecReviewVirustotalDataEmpty(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;

    return isInstance;
}

export function CRSFSecReviewVirustotalDataEmptyFromJSON(json: any): CRSFSecReviewVirustotalDataEmpty {
    return CRSFSecReviewVirustotalDataEmptyFromJSONTyped(json, false);
}

export function CRSFSecReviewVirustotalDataEmptyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewVirustotalDataEmpty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'detected_urls': !exists(json, 'detected_urls') ? undefined : json['detected_urls'],
    };
}

export function CRSFSecReviewVirustotalDataEmptyToJSON(value?: CRSFSecReviewVirustotalDataEmpty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'detected_urls': value.detected_urls,
    };
}

